import { ValidationErrors } from 'final-form';

import { validateCronExpressionOfTask } from './cronExpression';
import { validateLookBackPeriod } from './lookBackPeriodValidator';
import { LOOK_BACK_MAX_VALUE, LOOK_BACK_MIN_VALUE } from '../../components/forms/jobs/historicalData/HistoricalData';
import { HistoricalDataImportTaskType, ZoomCCConfigurationType } from '../../scene/integrations/types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const validateZoomCCForm = (values: ZoomCCConfigurationType): ValidationErrors => ({
  tasks: [
    {
      // user sync
      cronExpression: validateCronExpressionOfTask(values.tasks[0]),
    },
    {}, // adherence is not configured for zoom cc right now
    {
      // historical data validator
      cronExpression: validateCronExpressionOfTask(values.tasks[2]),
      taskProperties: {
        lookBackPeriod: validateLookBackPeriod(
          values.tasks[2] as HistoricalDataImportTaskType,
          LOOK_BACK_MIN_VALUE,
          LOOK_BACK_MAX_VALUE
        ),
      },
    },
  ],
  streams: [],
});
